const currency = new Intl.NumberFormat('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
/** Amounts from the API are integer cents; missing values are not zero. */
export function formatMoney(cent: number | null | undefined): string {
  return cent == null || !Number.isFinite(cent) ? '—' : `¥${currency.format(cent / 100)}`
}
